<script setup lang="ts">

import TimeOffList from "@/components/timeoff/TimeOffList.vue";
import TimeoffApprover from "@/components/timeoff/TimeoffApprover.vue";
import EditTimeoffTypeDialog from "@/components/timeoff/EditTimeoffTypeDialog.vue";
import Button from "primevue/button";
import {useAuthStore} from "@/stores";
import {ref} from "vue";
import {timeoffBackend, TimeoffDTO} from "@/backend/timeoff.backend.ts";
import useAppToast from "@/composables/useAppToast";

const toaster = useAppToast();
const all = ref<TimeoffDTO[] | null>(null);
const editDialogVisible = ref(false);
const editingTimeoff = ref<TimeoffDTO | null>(null);

const {isApprover, isAdmin} = useAuthStore();

const loadAll = async () => {
  all.value = await timeoffBackend.getAllTimeoff();
};

function openEditDialog(timeoff: TimeoffDTO) {
  editingTimeoff.value = timeoff;
  editDialogVisible.value = true;
}

async function handleTypeUpdated() {
  await loadAll();
}

</script>

<template>
  <TimeOffList :timeoffList="all" :hide-comment="!isAdmin" :exportable="isAdmin" @mounted="loadAll">
    <template #timeoffActions="slotProps" v-if="isApprover || isAdmin">
      <Button icon="pi pi-pencil" text severity="secondary"
              v-tooltip.top="'Edit type'"
              @click="openEditDialog(slotProps.data)"/>
      <TimeoffApprover :timeoff="slotProps.data" @refresh="loadAll" v-if="isApprover"/>
    </template>
  </TimeOffList>
  <EditTimeoffTypeDialog
    v-model:visible="editDialogVisible"
    :timeoff="editingTimeoff"
    @updated="handleTypeUpdated"
  />
</template>
